import { styled, Box } from '@mui/material';

export const PlanDetailsBoxStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '25px 40px',
  '@media (max-width: 1023px)': {
    display: 'block',
    justifyContent: 'center',
    textAlign: 'center',
    height: 'auto',
    padding: '0 40px 24px',
    marginTop: '12px',
  },
  '@media (min-width: 1024px)': {
    gap: '20px',
  },
});

export const PlanPremiumBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '280px',
  flex: '1 0 280px',
  height: '100%',

  '@media (max-width: 743px)': {
    display: 'block',
    justifyContent: 'center',
    marginBottom: '20px',
    paddingTop: '0',
    marginTop: '0',
    width: '100%',
  },
  '@media (max-width: 992px)': {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '20px',
  },
  '@media (min-width: 992px)': {
    flex: '1 0 280px',
  }
});

export const PremiumTextStyled = styled('div')({
  minHeight: '32px',

  '@media (min-width: 1200px)': {
    minHeight: '84px',
  },
  '& h2': {
    fontSize: 23,
    fontWeight: 600,
    lineHeight: 1.4,

    '@media (min-width: 1200px)': {
      fontSize: 46,
      fontWeight: 400,
      marginBottom: 0,
    },
  },
});

export const HsaEligibleBoxStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifySelf: 'end',
  marginTop: 'auto',
  width: '100%',
  padding: '12px 16px',
  borderRadius: 3,
  border: '1px solid #e8ab8d',
  backgroundColor: '#fefbf6',
  alignContent: 'center',
  '@media (min-width: 744px) and (max-width: 992px)': {
    marginBottom: '12px',
  },
});

export const ProviderWrapperStyled = styled(Box)({
  margin: '0 40px 24px',
});

export const ProviderBoxStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifySelf: 'end',
  marginTop: 'auto',
  width: '100%',
  padding: '12px 16px',
  borderRadius: 3,
  alignContent: 'center',
  border: '1px solid #cc560a',
  backgroundColor: '#fefbf6',
  '@media (max-width: 743px)': {
    // flexFlow: 'column',
  },
});

export const AddedProvidersBoxStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifySelf: 'end',
  marginTop: 'auto',
  width: '100%',
  padding: '12px 16px',
  borderRadius: 3,
  border: '1px solid #2A7527',
  backgroundColor: '#E7F4E6',
  alignContent: 'center',
  '& .view-more-providers-button': {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
  },

  '@media (max-width: 744px)': {
    flexFlow: 'column',
  },
});

export const ProviderTextWrappperStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignContent: 'center',
  '& .svg-wrapper': {
    display: 'flex',
    alignContent: 'center',
  },
});

export const ProviderTableStyled = styled(Box)({
  border: '1px solid #BBC1D0',
  borderRadius: '5px',
  marginTop: '16px',
  '& .covered': {
    width: '180px',
    justifyContent: 'flex-start',
    flex: 2,
  },
});

export const ProviderTableRowStyled = styled(Box)({
  borderBottom: '1px solid #BBC1D0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px 20px',
  '&:last-child': {
    borderBottom: 'none',
  },
  '& .change-provider-button': {
    display: 'flex',
    flex: 2,
    justifyContent: 'flex-end',
  },
});

export const NameColumnStyled = styled(Box)({
  flex: 0.3,
  '@media (min-width: 744px) and (max-width: 1199px)': {
    flex: 0.5,
  },
});

export const NameStyled = styled(Box)({
  display: 'flex',
  '& .truncate': {
    maxWidth: '12ch !important',
    width: 'auto ',
  },
  '@media (min-width: 744px) and (max-width: 1199px)': {
    borderLeft: 'none',
  },
});

export const ProviderInfoColumnStyled = styled(Box)({
  flex: 0.7,
  display: 'flex',
  justifyContent: 'space-between',
  borderLeft: '1px solid #BBC1D0',
  '@media (min-width: 744px) and (max-width: 1199px)': {
    flex: 0.5,
    borderLeft: '1px solid #BBC1D0',
    flexFlow: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'flex-start',
    gap: '2px',
  },
});
export const ProviderNameStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flex: 0.5,
  paddingLeft: '12px',
  maxWidth: '100%',
  '&:empty': {
    width: '0 !important',
  },
  '@media (min-width: 744px) and (max-width: 1199px)': {
    borderLeft: 'none',
    flex: 1,
  },
});

export const ProviderCodeStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '12px',
  maxWidth: '100%',
  '&:empty': {
    width: '0 !important',
  },
  '@media (min-width: 744px) and (max-width: 1199px)': {
    textAlign: 'center',
  },
});

export const ButtonWrapperStyled = styled(Box)({
  flex: '.7',
  '@media (min-width: 744px) and (max-width: 1199px)': {
    marginLeft: '20px',
    flex: 1,
  },
});

export const FallbackDetailsBoxStyled = styled(Box)({
  display: 'grid',
  backgroundColor: '#fbfbfb',
  border: '2px solid #f5f5f5',
  borderRadius: '5px',
  padding: '30px 14px',
  '@media (max-width: 992px)': {
    textAlign: 'left !important',
    marginTop: '12px',
  },
  '@media (min-width: 992px)': {
    width: '500px',
    height: '223px',
    alignItems: 'center',
  },
});

export const PremiumDetailPillStyled = styled(Box)({
  border: '1px solid #e6e6e6',
  borderRadius: '5px',
  backgroundColor: '#e6e6e6',
  padding: '4px 8px',
  width: 'fit-content',
  fontSize: '10px',
  textTransform: 'uppercase',
  lineHeight: '15px',
  marginTop: '6px',
});

export const ComparePlansStyled = styled(Box)({
  '@media (min-width: 1200px)': {
    borderRight: `1px solid #BBC1D0`,
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    padding: '2.4rem 0',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  '@media (max-width: 1199px)': {
    boxShadow: '0px 1px 10px 0px rgba(0, 0, 0, 0.24)',
    borderRadius: '8px',
    padding: '14px 12px',
    backgroundColor: '#ffffff',
    img: {
      height: '24px',
    },
  },
});

export const VersesTypographyStyled = styled(Box)({
  fontSize: '16px',
  color: '#CFCFCF',
  border: '1px solid #CFCFCF',
  borderRadius: '100%',
  position: 'relative',
  width: '36px',
  height: '36px',
  padding: '0.5rem',
  textAlign: 'center',
  marginLeft: '4rem',
  backgroundColor: '#FFF',
  zIndex: 1,
});

export const VersesStyled = styled(Box)({
  borderBottom: '1px solid #CFCFCF',
  rotate: '108deg',
  position: 'relative',
  width: '80px',
  right: '58px',
});
